module.exports = __webpack_public_path__ + "img/video-arrow-down-left.5847da41.svg";